import React from "react";
import {
  Box,
  Grid,
  Tabs,
  Tab,
  Typography,
  Avatar,
  Tooltip,
} from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ChatIcon from "@mui/icons-material/Chat";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import AuthContext, { useAuth } from "../../contexts/AuthContext";
import { Menu, MenuItem } from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import AccessLocalStorage from "../../services/localStorage";
import { header, headerEven, homeSideBarTitleText, IconBell, label, pcolor, pointer } from "../../style2";

function Newheader({ show_back_button, show_profile_button, tab_disabled = false, fullWidth = false }) {

  const history = useHistory();
  const location = useLocation();
  const ls = new AccessLocalStorage();
  
  const handleTabChange = (event, newValue) => {
    history.push(newValue);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  //let { logoutUser } = useContext(AuthContext);
  let auth = useAuth();
  let professional = ls.getProfessional();
  // Define style objects for header and headerEven
  const isHomeActive = location.pathname === "/" || location.pathname === "/patient_profile" || location.pathname === "/health_profile" ||  location.pathname.startsWith("/aisummarydashboard");
  return (
    <Box sx={fullWidth ? headerEven : header}>
      <Grid container alignItems="center">
        <Grid item xs={1} sm={1} lg={1} >
          {show_back_button && (
            <ArrowBackIcon onClick={() => history.goBack()} sx={{ ...pointer, fontSize:"2rem" }} />
          )}
        </Grid>
        <Grid item xs={9} sm={8} lg={8}>
          <Tabs value={isHomeActive ? "/" : location.pathname} onChange={handleTabChange} centered indicatorColor="primary" textColor="primary"
            TabIndicatorProps={{ style: { backgroundColor: pcolor, height: "4px" } }} >
            <Tab disabled={tab_disabled} label="Home" sx={{ fontSize: "1.15rem", minWidth:"160px", textTransform: "Capitalize", ...(isHomeActive ? label : {}) }} value="/" icon={<HomeOutlinedIcon sx={{ fontSize: "2.2rem" }} />} />
            <Tab disabled={tab_disabled} sx={{ fontSize: "1.15rem", minWidth:"160px", textTransform: "Capitalize", ...(location.pathname === "/contact" ? label : {})  }} label="Contact" value="/contact" icon={<ChatIcon sx={{ fontSize: "2.2rem" }} />}></Tab>
            <Tab disabled={tab_disabled} sx={{ fontSize: "1.15rem", minWidth:"160px", textTransform: "Capitalize", ...(location.pathname === "/newnotification" ? label : {})  }} label="Notifications" value="/newnotification" icon={<NotificationsIcon sx={{ fontSize: "2.2rem" }} />} />
          </Tabs>
        </Grid>
        <Grid item xs={3} sm={3} lg={3}>
          <Grid container spacing={2} justifyContent="flex-end" alignItems="center">

            {/* {show_profile_button ? (
                <Button
                  className={classes.button}
                  component={Link}
                  to="/professional_profile"
                > */}
            {/* <Grid item>
                    <Typography variant="body2" component="span">
                      Full name
                    </Typography>
                    <Typography variant="caption" display="block" gutterBottom>
                      Profession
                    </Typography>
                  </Grid> */}
            {/* </Button>
              ) : null} */}

            <Grid item sx={{ textAlign: "right" }}>
              <Typography  sx={homeSideBarTitleText}>
                {professional !== null ? `${professional.name}` : "User"}
              </Typography>
              {professional !== null && professional.title !== "" ? <Typography  sx={homeSideBarTitleText}>
                {professional.title}
              </Typography> : null}
            </Grid>
            <Grid item sx={IconBell}>
              <Tooltip title="Account">
                <Avatar onClick={handleClick} sx={{ backgroundColor: pcolor, ...pointer }}></Avatar>
              </Tooltip>
              <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center", }} sx={{ top: 2 }}>
                <MenuItem onClick={() => { history.push("/professional_profile"); handleClose(); }}>
                  <PersonIcon />
                  <Box m={1} />
                  My Profile
                </MenuItem>
                <MenuItem onClick={() => { auth.logoutUser(); handleClose(); }}>
                  <LogoutIcon />
                  <Box m={1} />
                  Logout
                </MenuItem>
              </Menu>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Newheader;
